import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, enableProdMode } from '@angular/core';
enableProdMode();
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ApolloModule } from "apollo-angular";
import { AppComponent } from './app.component';
import { NgxSpinnerModule } from 'ngx-spinner';

import { TestQueryModule } from './test/query.test.module'
//import { SharedModule } from './shared/shared.module';
import { QueryTestComponent } from './test/query.test.component';

@NgModule({
  declarations: [
    AppComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    RouterModule.forRoot([
      { path: '', component: QueryTestComponent, pathMatch: 'full' },
    ]),
    //SharedModule,
    ApolloModule,
    TestQueryModule,
    NgxSpinnerModule
  ],
  exports:[NgxSpinnerModule ],
  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule {
  
  // client = new ApolloClient({
  //   uri: "http://85.214.209.214:44444/graphql"
  // });

  // constructor(
  //   apollo: Apollo,
  //   httpLink: HttpLink
  // ) {
  //   apollo.create({
  //     link: httpLink.create({ uri: 'http://85.214.209.214:44444/graphql' }),
  //     cache: new InMemoryCache()
  //   });
  // }
}
